<p-menubar
  [model]="menuBarItems"
  [autoDisplay]="false"
  [styleClass]="
    globalStore.activeTheme() === 'hyperion-light'
      ? 'bg-blue-50 mx-1 my-2 gap-2 border-round-xl border-blue-300'
      : 'hyperion-dark mx-1 my-2 gap-2 border-round-xl border-blue-300'
  ">
  <ng-template pTemplate="start">
    <div class="flex gap-2">
      <p-button
        (click)="goToLandingpage()"
        [rounded]="true"
        icon="fas fa-home"></p-button>
      @if (
        topicItems && topicItems.length > 0 && globalStore.activeTopic();
        as topic
      ) {
        <p-button
          severity="info"
          (onClick)="menu.toggle($event)"
          [rounded]="true"
          [icon]="'fas fa-' + topic.icon"></p-button>

        <p-menu #menu [model]="topicItems" [popup]="true" />
      }
    </div>
  </ng-template>

  <ng-template pTemplate="item" let-item>
    <a
      pRipple
      class="flex align-items-center p-menuitem-link gap-2"
      [routerLink]="item.routerLink || null"
      [routerLinkActive]="'p-menuitem-link-active'"
      [pTooltip]="item.pTooltip">
      @if (item.icon) {
        <span [class]="item.icon"></span>
      }
      <span class="p-menuitem-text">{{ item.label }}</span>
      @if (item.items && item.items.length > 0) {
        <i class="fas fa-chevron-down text-xs"></i>
      }
    </a>
  </ng-template>

  <ng-template pTemplate="end">
    <div class="justify-content-end flex flex-1 align-items-center gap-2">
      <app-atlas-search></app-atlas-search>
      @if (
        activeUserStore.context() !== 'atlasExternal' &&
        activeUserStore.canAccessEntityAdder()
      ) {
        @for (item of topItems; track $index) {
          <p-splitButton
            class="sm:flex hidden"
            [rounded]="true"
            [raised]="true"
            [text]="true"
            size="small"
            styleClass="surface-0"
            [icon]="item.icon"
            (onClick)="quickSave()"
            [model]="item.items">
            <ng-template pTemplate="dropdownicon">
              <i class="fas fa-chevron-down"></i>
            </ng-template>
          </p-splitButton>
        }
      }

      <app-theme-switcher></app-theme-switcher>

      <p-button
        icon="fas fa-info"
        size="small"
        styleClass="surface-0"
        [raised]="true"
        [text]="true"
        [rounded]="true"
        (click)="showInfo()"></p-button>
      <p-button
        icon="fas fa-ellipsis-vertical"
        size="small"
        [rounded]="true"
        [raised]="true"
        [text]="true"
        styleClass="surface-0"
        (onClick)="menu.toggle($event)" />
      <p-menu #menu [model]="miscItems" [popup]="true" styleClass="w-20rem">
        <ng-template pTemplate="item" let-item>
          @if (item.url) {
            <a class="p-menuitem-link" target="_blank" [href]="item.url">
              <div class="flex align-items-center">
                <i class="p-menuitem-icon" [class]="item.icon"></i>
                <div>
                  <span>{{ item.label }}</span>
                  @if (item.sub) {
                    <div class="text-xs text-color-secondary mt-2">
                      {{ item.sub }}
                    </div>
                  }
                </div>
              </div>
            </a>
          } @else {
            <a
              class="p-menuitem-link"
              [routerLink]="item.routerLink"
              [target]="item.target || '_self'">
              <div class="flex align-items-center">
                <i class="p-menuitem-icon" [class]="item.icon"></i>
                <div>
                  <span>{{ item.label }}</span>
                  @if (item.sub) {
                    <div class="text-xs text-color-secondary mt-2">
                      {{ item.sub }}
                    </div>
                  }
                </div>
              </div>
            </a>
          }
        </ng-template>
      </p-menu>
      <app-active-user-avatar
        size="large"
        [icon]="
          activeUserStore.context() === 'atlasExternal'
            ? 'fas fa-earth-europe'
            : 'fas fa-house-user'
        "
        [addBookmarks]="true"
        [styleClass]="'ml-2 bg-primary'"></app-active-user-avatar>
    </div>
  </ng-template>
</p-menubar>
<p-confirmDialog key="overwriteBookmark" #cd>
  <ng-template pTemplate="headless" let-message>
    <div class="p-card border-round pt-1 p-4">
      <app-header
        icon="fas fa-floppy-disk"
        [text]="message.header"></app-header>

      <div class="flex">
        Ihre Ansicht wird mit der aktuellen Ansicht überschrieben.
      </div>

      <div class="flex align-items-center gap-3 mt-4">
        <button
          [rounded]="true"
          [outlined]="true"
          severity="secondary"
          pButton
          icon="fas fa-times"
          label="nein, abbrechen"
          (click)="cd.reject()"></button>
        <button
          [rounded]="true"
          pButton
          icon="fas fa-check"
          label="ja, speichern"
          (click)="cd.accept()"
          class="ml-auto"></button>
      </div>
    </div>
  </ng-template>
</p-confirmDialog>

<p-dialog [modal]="true" [(visible)]="infoVisible" [style]="{ width: '60rem' }">
  <ng-template pTemplate="header">
    <app-header
      icon="fas fa-info-circle"
      [text]="'Willkommen im Kommunal-Atlas!'"
      styleClass="m-0"></app-header>
  </ng-template>

  <p>Liebe Nutzer:innen,</p>

  <p>
    der Kommunal-Atlas bietet Ihnen die Möglichkeit, kommunale Daten interaktiv,
    übersichtlich und individuell aufzubereiten. Kleinräumige Analysen,
    Zeitvergleiche und verschiedene Darstellungsformen helfen Ihnen dabei,
    Entwicklungen und Zusammenhänge schnell zu erkennen.
  </p>
  <p>
    Über die obere Menüleiste gelangen Sie zu verschiedenen Themenbereichen. Mit
    dem Jahres-Slider können Sie Zeiträume vergleichen und so Trends sichtbar
    machen. Der Nachtmodus (aktivierbar über das Mond-Icon
    <i class="fas fa-moon"></i> oben rechts) sorgt bei Bedarf für eine
    augenschonende Darstellung.
  </p>
  <p>
    Nutzen Sie die Suchleiste daneben, um gezielt nach Indikatoren,
    (Teil-)Räumen, Standorten, Ansichten, Berichten oder Themen zu suchen und
    sich die passenden Inhalte anzeigen zu lassen.
  </p>
  <p>
    Ein Highlight ist der Bereich „Erstellen“, den Sie über das Haus-Icon oben
    links auf der Startseite erreichen. Hier können Sie ganz flexibel eigene
    Ansichten gestalten – zum Beispiel mit Kreisdiagrammen, Liniendiagrammen
    oder Tabellen – und diese individuell anpassen.
  </p>
  <p>
    Im rechten unteren Bildschirmbereich finden Sie zwei weitere hilfreiche
    Funktionen. Mit dem Klemmbrett-Icon
    <i class="fa-clipboard-list"></i> erstellen Sie Vergleichsberichte, in denen
    Sie Icon Teilräume oder Standorte über alle Indikatoren hinweg
    gegenüberstellen können.
  </p>
  <p>
    Das Stift-Icon <i class="fas fa-pen"></i> erlaubt es Ihnen, eine bestehende
    Ansicht direkt zu bearbeiten – etwa die Größe von Diagrammen zu verändern
    oder eigene Diagramme hinzuzufügen.
  </p>

  <p>Viel Freude beim Erkunden, Vergleichen und Gestalten!</p>

  <app-header
    styleClass="mt-6"
    text="Die wichtigsten Funktionen im Überblick:"></app-header>

  <p>
    Daten, auch der nicht aufbereiteten, stehen Ihnen die „Suche“ und der
    „Erstellen“-Button zur Verfügung. Hier finden Sie alle Daten der Kommune und
    können Ihre eigenen Diagramme und Berichte erstellen.
  </p>

  <app-header styleClass="mt-6" text="Zurück zur Startseite"> </app-header>
  <p>
    Ein Klick auf das Haus-Icon bringt Sie jederzeit zurück zur Startseite des
    Kommunal-Atlas.
  </p>

  <app-header styleClass="mt-6" text="Wo bin ich gerade?"></app-header>
  <p>
    Oben links neben dem Haus-Icon sehen Sie das Symbol des Themas, in dem Sie
    sich aktuell befinden (sofern angelegt). Ein Klick darauf öffnet ein
    praktisches Dropdown-Menü, das Ihnen alle Themen und Themenbereiche anzeigt
    – so können Sie sich bequem durch den Atlas bewegen.
  </p>

  <app-header styleClass="mt-6" text="Navigation oben"></app-header>

  <p>
    Die Navigation am oberen Bildschirmrand besteht aus einzelnen Dropdowns und
    führt Sie schnell zu verschiedenen Themenbereichen oder in die Teilräume der
    Kommune (sofern angelegt). Hier können Sie sich durch die Inhalte klicken
    und neue Daten entdecken.
  </p>

  <app-header
    styleClass="mt-6"
    text="Zeitvergleiche mit dem Jahres-Slider"></app-header>
  <p>
    Nutzen Sie den Jahres-Slider, um verschiedene Jahre miteinander zu
    vergleichen und Entwicklungen sichtbar zu machen (sofern aktiviert).
  </p>

  <app-header styleClass="mt-6" text="Gezielte Suche"></app-header>
  <p>
    In der Suchleiste oben rechts können Sie gezielt nach Indikatoren,
    (Teil-)Räumen, Standorten, Ansichten, Berichten oder Themen suchen – und
    sich genau die Informationen anzeigen lassen, die Sie interessieren.
  </p>

  <app-header
    styleClass="mt-6"
    text="Weitere Funktionen unten rechts"></app-header>

  <p>
    Im rechten unteren Bereich des Bildschirms finden Sie weitere nützliche
    Tools:
  </p>
  <p>
    Mit dem Klemmbrett-Icon <i class="fas fa-clipboard-list"></i> erstellen Sie
    Vergleichsberichte, in denen Sie beliebige Teilräume oder Standorte über
    alle Indikatoren hinweg miteinander vergleichen können.
  </p>
  <p>
    Über das Werkzeug-Icon <i class="fas fa-wrench"></i> die Ansicht leeren und
    von vorne beginnen.
  </p>

  <p>
    Mit dem Stift-Icon <i class="fas fa-pen"></i> bearbeiten Sie die aktuelle
    Ansicht: Passen Sie z. B. die Größe von Diagrammen an oder fügen Sie eigene
    Diagramme hinzu.
  </p>

  <app-header styleClass="mt-6" text="Im Bearbeitungs-Modus"></app-header>
  <p>
    Über das Plus-Icon <i class="fas fa-plus-circle"></i> fügen Sie eine neue
    Darstellung hinzu.
  </p>
  <p>
    Über das Augen-Icon <i class="fas fa-eye"></i> wechseln Sie wieder in den
    Lese-Modus.
  </p>
</p-dialog>
